// Nature économique d'une facture — logique PURE : aucun DOM, aucun réseau.
//
// La règle de RÉSOLUTION (quelle facture est une charge) vit en SQL, dans la vue
// domi.v_facture_nature, et NULLE PART AILLEURS. Ce module ne la rejoue pas : il
// se contente d'habiller ce que le serveur a déjà tranché. C'est délibéré — la
// clé de groupe de l'étiquetage, elle, existe en double (SQL + JS) et le fichier
// de l'Edge Function porte l'avertissement « les deux DOIVENT donner la même
// clé ». Une seule règle à un seul endroit ne peut pas diverger.

/** Libellés lisibles des catégories. La liste fait foi côté base (domaine
 *  domi.categorie_charge) ; ici on ne fait que traduire pour l'œil. */
const LIBELLE_CATEGORIE = {
  loyer: "loyer",
  energie: "énergie",
  assurance: "assurance",
  impot: "impôts et taxes",
  abonnement: "abonnement",
  credit: "intérêts et crédit",
  personnel: "personnel",
  telecom: "télécom",
  maintenance: "maintenance",
  note_de_frais: "note de frais",
  autre: "autre charge",
};

/**
 * La pastille à afficher sur une ligne de facture, ou null s'il n'y a rien à
 * signaler.
 *
 * Rien n'est affiché pour une marchandise : c'est le cas normal, et une pastille
 * posée sur 98 % des lignes n'attire plus l'œil sur les 2 % qui comptent.
 */
export function pastilleNature(row) {
  if (!row || row.nature === "marchandise" || row.nature == null) return null;
  if (row.nature === "autre") {
    return { texte: "à classer", classe: "pill nature-autre" };
  }
  const cat = LIBELLE_CATEGORIE[row.nature_categorie] || "charge";
  return { texte: cat, classe: "pill nature-charge" };
}

/**
 * La phrase de ventilation sous les totaux d'une liste.
 *
 * ⚠️ Elle ne s'affiche QUE s'il y a des charges dans la sélection courante. Un
 * « dont 0 € de charges » permanent apprendrait à l'œil à sauter la ligne, et
 * elle ne serait plus lue le jour où elle porte un montant.
 *
 * Le total affiché au-dessus reste le TOTAL COMPLET, charges comprises : c'est
 * ce qui correspond aux lignes visibles, donc ce qu'un titulaire peut
 * recalculer à la main. Cette phrase dit comment il se décompose, elle n'en
 * retranche rien.
 */
export function ventilation(totaux) {
  if (!totaux) return null;
  const n = Number(totaux.n_charge || 0);
  if (!Number.isFinite(n) || n <= 0) return null;
  const ht = Number(totaux.ht_charge || 0);
  const piece = n === 1 ? "pièce" : "pièces";
  return { nCharge: n, htCharge: ht, piece };
}

/**
 * Vrai si la nature vient d'un arbitrage humain plutôt que du défaut.
 *
 * Sert à distinguer, dans l'interface, « Mehdi a décidé que c'était une charge »
 * de « personne n'a rien dit, donc c'est compté en marchandise ». Un chiffre
 * dont on ignore s'il repose sur une décision ou sur un défaut ne se défend pas
 * devant un comptable.
 */
export function natureDecidee(row) {
  if (!row) return false;
  return row.origine_nature === "exception_facture"
      || row.origine_nature === "fournisseur"
      || row.origine_nature === "type_document";
}
